export default __webpack_public_path__ + "static/media/Resume.f5c11904.pdf";